//
import { TopologyMap } from 'components'
import VideoPlayerModal from '../VideoPlayerModal'
import ShowDataNode from '../showDataNode'
import AlarmEventsModal from '../alarmEventsModal'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js'
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {getRegionList, getMapNodeModelList, getMapList} from '@/api/get-data.js'
import {getRecordById} from '@/utils/public'
import {formatPlayUrl} from '@/utils/video-player'
import {getOneWeekBeginAndEndDate, getDayTextOfWeek} from '../../../utils/date'
import {statResourceCount, statNormalResourceCount, statOfflineResourceCount, statAlarmResourceCount} from './mapAction'

export default {
  name: 'MapNavigator',
  data () {
    return {
      topologyMap: null,
      canvasOptions: {
        rotateCursor: '',
        activeColor: 'red', // 选中层颜色
        hoverColor: 'green', // 活动层颜色
        hideInput: true, // 是否禁止双击节点文字，出现文字输入框
        hideRotateCP: true, // 是否隐藏节点旋转控制点
        hideSizeCP: true, // 是否隐藏节点大小控制点
        disableEmptyLine: true, // 是否禁止连线终点为空（未连接到节点）
        locked: 1 // 0-None，未锁定，可任意编辑；1-Readonly，只读模式，允许选中；2-NoMove，不能移动，10-NoEvent，禁止鼠标交互，无法做任何操作，纯静态画面模式
      },
      // 地图节点数组
      mapNodes: [],
      textMapActionMapNodes: [],
      mapNodeQueryParams: {
        mapId: 0,
        mapNodeId: 0,
        imageUrlRequired: 1,
        pageNum: 1,
        pageSize: 1000
      },
      mapMapNodeCount: 0,
      regionMapNodeCount: 0,
      streamNodeMapNodeCount: 0,
      dataNodeMapNodeCount: 0,
      controlNodeMapNodeCount: 0,
      realEventMapNodeCount: 0,
      mapActionMapNodeCount: 0,
      textMapActionMapNodeCount: 0,
      // 区域数组
      lastRegionUpdateDateTime: 0,
      regionLoadRequired: false, // 区域是否需加载
      regionQueryParams: {
        regionId: 0,
        regionIds: [],
        parentRegionId: 0,
        regionKind: 0,
        beginUpdateDateTime: 0,
        pageNum: 1,
        pageSize: 1000
      },
      // 视频节点数组
      streamNodes: [],
      lastStreamNodeUpdateDateTime: 0,
      streamNodeQueryParams: {
        regionId: 0,
        descendantRegionRequired: 1,
        nodeIds: [],
        streamObjectKind: 255,
        systemKind: this.defaultSystemKind,
        encoderStateRequired: 1,
        gpsRequired: 0,
        streamServerInfoRequired: 1,
        auxMonitoringDeviceId: 0,
        beginUpdateDateTime: 0,
        orderBy: 0,
        pageNum: 1,
        pageSize: 1000
      },
      // 数据节点数组
      dataNodes: [],
      lastDataNodeUpdateDateTime: 0,
      dataNodeQueryParams: {
        regionId: 0,
        descendantRegionRequired: 1,
        nodeIds: [],
        resourceKind: 255,
        gaugedObjectKind: 255,
        systemKind: this.defaultSystemKind,
        encoderStateRequired: 1,
        gpsRequired: 0,
        auxMonitoringDeviceId: 0,
        beginUpdateDateTime: 0,
        orderBy: 0,
        pageNum: 1,
        pageSize: 1000
      },
      // 控制节点数组
      controlNodes: [],
      lastControlNodeUpdateDateTime: 0,
      controlNodeQueryParams: {
        regionId: 0,
        descendantRegionRequired: 1,
        nodeIds: [],
        resourceKind: 255,
        controlledObjectKind: 255,
        systemKind: this.defaultSystemKind,
        dataNodeStateRequired: 1,
        encoderStateRequired: 1,
        gpsRequired: 0,
        beginUpdateDateTime: 0,
        orderBy: 0,
        pageNum: 1,
        pageSize: 1000
      },
      // 实时事件数组
      realEvents: [],
      lastRealEventUpdateDateTime: 0,
      realEventMapNodeEventLoaded: false,
      // 地图动作数组
      mapActions: [],
      lastMapActionUpdateDateTime: 0,
      mapActionQueryParams: {
        mapActionId: 0,
        beginUpdateDateTime: 0,
        orderBy: 0,
        pageNum: 1,
        pageSize: 1000
      },
      // 最后更新资源数组
      lastUpdateRegionMapNodes: [],
      lastUpdateStreamNodeMapNodes: [],
      lastUpdateDataNodeMapNodes: [],
      lastUpdateControlNodeMapNodes: [],
      lastUpdateRealEventsMapNodes: [],
      lastUpdateMapActionMapNodes: [],
      // 当前资源
      currentRegion: null,
      currentStreamNode: null,
      currentDataNode: null,
      currentDoControlNode: null,
      currentAoControlNode: null,
      currentRealEvents: null,
      currentMapAction: null,
      // 视频播放器弹窗
      activeStreamNodes: [],
      videoPlayerModalOpen: false,
      videoPlayerModalVideoOpen: false, // 打开视频标识
      // 数据节点信息弹窗
      showDataNodeModalOpen: false,
      textMapActionPollingTimer: null,
      textMapActionPollingTimes: 0,
      pollingTimer: null,
      pollingTimes: 0,
      // 事件集合信息弹窗
      eventsModalOpen: false
    }
  },
  props: {
    defaultMapId: {
      type: Number,
      default() {
        return 0
      }
    },
    defaultRegionId: {
      type: Number,
      default() {
        return 0
      }
    },
    defaultSystemKind: {
      type: Number,
      default() {
        return 0
      }
    },
    // 是否默认加载根地图
    rootMapRequired: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 是否启用根据系统种类过滤地图节点
    mapNodeBySystemKindFiltered: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  components: {
    TopologyMap,
    VideoPlayerModal,
    ShowDataNode,
    AlarmEventsModal
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  mounted() {
    this.topologyMap = this.$refs.topologyMap
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      getMapNodeModelList(() => {
        getMapList(() => {
          if (this.$globalData.maps.length) {
            if (this.defaultMapId > 0) {
              this.$refs.topologyMap.loadMapByMapId(this.defaultMapId)
            } else if (this.defaultRegionId > 0) {
              this.$refs.topologyMap.loadMapByRegionId(this.defaultRegionId, this.defaultSystemKind)
            } else if (this.rootMapRequired) {
              this.$refs.topologyMap.loadRootMap()
            }
          }
        })
      })
    })
  },
  beforeDestroy() {
  },
  methods: {
    // 查询地图节点列表
    getMapNodeList() {
      return new Promise((resolve, reject) => {
        this.loading = true
        if (this.topologyMap.currentMap) {
          this.mapNodeQueryParams.mapId = this.topologyMap.currentMap.id
        }
        this.$http(this.$api.mapNodeList, this.mapNodeQueryParams).then(
          res => {
            if (res.code === 200) {
              this.mapNodes = res.data
              this.textMapActionMapNodes = []
              // 遍历地图种类的地图节点
              this.mapNodes.forEach(mapNode => {
                mapNode.resource = null
                mapNode.valueText = ''

                if (mapNode.resourceKind === 29) { // 地图
                  ++this.mapMapNodeCount
                  let map = getRecordById(mapNode.resourceId, this.$globalData.maps)
                  if (map) {
                    mapNode.resource = map
                  }
                } else if (mapNode.resourceKind === 150) { // 区域
                  ++this.regionMapNodeCount
                } else if (mapNode.resourceKind === 21) { // 视频节点
                  ++this.streamNodeMapNodeCount
                } else if (mapNode.resourceKind === 22 || mapNode.resourceKind === 23) { // 数据节点
                  ++this.dataNodeMapNodeCount
                } else if (mapNode.resourceKind === 24 || mapNode.resourceKind === 25) { // 控制节点
                  ++this.controlNodeMapNodeCount
                } else if (mapNode.resourceKind === 51) { // 事件集合
                  ++this.realEventMapNodeCount
                } else if (mapNode.resourceKind === 71) { // 地图动作
                  ++this.mapActionMapNodeCount
                  if (mapNode.resourceSubType >= 100 && mapNode.resourceSubType <= 199) { // 文本类型地图动作
                    ++this.textMapActionMapNodeCount
                    this.textMapActionMapNodes.push(mapNode)
                  }
                }
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          resolve(err)
        })
      })
    },
    // 查询区域列表
    getRegionList() {
      return new Promise((resolve, reject) => {
        if (this.regionMapNodeCount === 0 && this.mapMapNodeCount === 0 && !this.regionLoadRequired) { // 区域、地图地图节点都不存在以及区域不需加载，直接返回
          resolve({})
          return
        }

        this.loading = true
        if (this.lastRegionUpdateDateTime > 0) {
          this.regionQueryParams.beginUpdateDateTime = this.lastRegionUpdateDateTime + 1
        }

        if (this.$globalData.regions.length === 0) { // 首次加载区域列表
          getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
            this.lastUpdateRegionMapNodes = []
            this.$globalData.regions.forEach(region => {
              if (region.updateDateTime > this.lastRegionUpdateDateTime) { // 更新最后更新日期时间
                this.lastRegionUpdateDateTime = region.updateDateTime
              }
              this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                if (mapNode.resourceKind === 150 && region.id === mapNode.resourceId) { // 区域
                  // mapNode.value = region.realValue
                  // mapNode.valueText = region.encoderCount
                  mapNode.resource = region
                  this.lastUpdateRegionMapNodes.push(mapNode)
                }
                if (mapNode.resourceKind === 29 && mapNode.resource && mapNode.resource.mapRegionId > 0 && // 地图
                    region.id === mapNode.resource.mapRegionId) { // 更新映射区域告警数和在线状态
                  mapNode.resource.alarmCount = region.streamNodeAlarmCount + region.dataNodeAlarmCount + region.locationNodeAlarmCount + region.voiceNodeAlarmCount
                  mapNode.resource.isOnline = (region.encoderCount > 0 && region.encoderCount === region.encoderOfflineCount) ? 0 : 1
                  this.lastUpdateRegionMapNodes.push(mapNode)
                }
              })
            })
            this.loading = false
            resolve({})
          })
        } else {
          this.$http(this.$api.regionList, this.regionQueryParams).then(
            res => {
              if (res.code === 200 && res.data.length) {
                res.data.forEach(item => { // 更新区域数据
                  for (let index in this.$globalData.regions) {
                    if (this.$globalData.regions[index].id === item.id) {
                      let realParentRegionId = this.$globalData.regions[index].realParentRegionId
                      let parentRegionId = this.$globalData.regions[index].parentRegionId
                      this.$globalData.regions[index] = item
                      if (realParentRegionId) { // 实际父区域id为真，说明父区域id做过处理，需恢复
                        this.$globalData.regions[index].realParentRegionId = realParentRegionId
                        this.$globalData.regions[index].parentRegionId = parentRegionId // 恢复原始父区域id
                      }
                      break
                    }
                  }
                })

                this.lastUpdateRegionMapNodes = []
                res.data.forEach(region => {
                  if (region.updateDateTime > this.lastRegionUpdateDateTime) { // 更新最后更新日期时间
                    this.lastRegionUpdateDateTime = region.updateDateTime
                  }
                  this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                    if (mapNode.resourceKind === 150 && region.id === mapNode.resourceId) { // 区域
                      // mapNode.value = region.realValue
                      // mapNode.valueText = region.encoderCount
                      mapNode.resource = region
                      this.lastUpdateRegionMapNodes.push(mapNode)
                    }
                    if (mapNode.resourceKind === 29 && mapNode.resource && mapNode.resource.mapRegionId > 0 && // 地图
                      region.id === mapNode.resource.mapRegionId) { // 更新映射区域告警数和在线状态
                      mapNode.resource.alarmCount = region.streamNodeAlarmCount + region.dataNodeAlarmCount + region.locationNodeAlarmCount + region.voiceNodeAlarmCount
                      mapNode.resource.isOnline = (region.encoderCount > 0 && region.encoderCount === region.encoderOfflineCount) ? 0 : 1
                      this.lastUpdateRegionMapNodes.push(mapNode)
                    }
                  })
                })
              }
              this.loading = false
              resolve(res)
            }).catch(err => {
            console.log(err)
            this.loading = false
            resolve(err)
          })
        }
      })
    },
    // 查询视频节点列表
    getStreamNodeList() {
      return new Promise((resolve, reject) => {
        if (this.streamNodeMapNodeCount === 0) { // 地图节点不存在，直接返回
          resolve({})
          return
        }

        console.log('当前组态画面视频节点资源数量为' + this.streamNodeMapNodeCount)
        this.loading = true
        if (this.streamNodeQueryParams.nodeIds.length === 0) {
          this.mapNodes.forEach(item => { // 汇总视频节点id
            if (item.resourceKind === 21 && item.resourceId > 0) {
              this.streamNodeQueryParams.nodeIds.push(item.resourceId)
            }
          })
          if (this.streamNodeQueryParams.nodeIds.length === 0) {
            this.loading = false
            resolve({})
            return
          }
        } else {
        }

        if (this.lastStreamNodeUpdateDateTime > 0) {
          this.streamNodeQueryParams.beginUpdateDateTime = this.lastStreamNodeUpdateDateTime + 1
        }

        this.$http(this.$api.streamNodeList, this.streamNodeQueryParams).then(
          res => {
            if (res.code === 200 && res.data.length) {
              if (this.streamNodes.length === 0) {
                res.data.forEach(item => {
                  item.playUrl = formatPlayUrl(this.$globalConfig.playProtocol, item.id, item.streamOpenMode, 0,
                    item.streamServerIp, item.streamServerPort3, this.$store.getters.userToken) // 端口3为rtmp/hls/flv端口
                })
                this.streamNodes = res.data
              } else {
                res.data.forEach(item => { // 更新视频节点数据
                  for (let index in this.streamNodes) {
                    if (this.streamNodes[index].id === item.id) {
                      item.playUrl = formatPlayUrl(this.$globalConfig.playProtocol, item.id, item.streamOpenMode, 0,
                        item.streamServerIp, item.streamServerPort3, this.$store.getters.userToken) // 端口3为rtmp/hls/flv端口
                      this.streamNodes[index] = item
                      break
                    }
                  }
                })
              }

              this.lastUpdateStreamNodeMapNodes = []
              res.data.forEach(item => {
                if (item.updateDateTime > this.lastStreamNodeUpdateDateTime) { // 更新最后更新日期时间
                  this.lastStreamNodeUpdateDateTime = item.updateDateTime
                }
                this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                  if (item.id === mapNode.resourceId && mapNode.resourceKind === 21) {
                    // mapNode.value = streamNode.realValue
                    mapNode.valueText = this.$type.getResourceAlarmStateText(21, item.alarmState, item.eventTypeSet, 1,
                      item.encoderAlarmState, item.encoderEventTypeSet)
                    mapNode.resource = item
                    this.lastUpdateStreamNodeMapNodes.push(mapNode)
                  }
                })
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          resolve(err)
        })
      })
    },
    // 查询数据节点列表
    getDataNodeList() {
      return new Promise((resolve, reject) => {
        if (this.dataNodeMapNodeCount === 0) { // 地图节点不存在，直接返回
          resolve({})
          return
        }

        console.log('当前组态画面数据节点资源数量为' + this.dataNodeMapNodeCount)
        this.loading = true
        if (this.dataNodeQueryParams.nodeIds.length === 0) {
          this.mapNodes.forEach(item => { // 汇总数据节点id
            if ((item.resourceKind === 22 || item.resourceKind === 23) && item.resourceId > 0) {
              this.dataNodeQueryParams.nodeIds.push(item.resourceId)
            }
          })
          if (this.dataNodeQueryParams.nodeIds.length === 0) {
            this.loading = false
            resolve({})
            return
          }
        } else {
        }

        if (!this.mapNodeBySystemKindFiltered) { // 未启用根据系统种类过滤地图节点，则不过滤
          this.dataNodeQueryParams.systemKind = 0
        }
        if (this.lastDataNodeUpdateDateTime > 0) {
          this.dataNodeQueryParams.beginUpdateDateTime = this.lastDataNodeUpdateDateTime + 1
        }

        this.$http(this.$api.dataNodeList, this.dataNodeQueryParams).then(
          res => {
            if (res.code === 200 && res.data.length) {
              if (this.dataNodes.length === 0) {
                this.dataNodes = res.data
              } else {
                res.data.forEach(item => { // 更新数据节点数据
                  for (let index in this.dataNodes) {
                    if (this.dataNodes[index].id === item.id) {
                      this.dataNodes[index] = item
                      break
                    }
                  }
                })
              }

              this.lastUpdateDataNodeMapNodes = []
              res.data.forEach(dataNode => {
                if (dataNode.updateDateTime > this.lastDataNodeUpdateDateTime) { // 更新最后更新日期时间
                  this.lastDataNodeUpdateDateTime = dataNode.updateDateTime
                }
                this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                  if (dataNode.id === mapNode.resourceId && dataNode.resourceKind === mapNode.resourceKind) {
                    if (dataNode.resourceKind === 22 && this.$type.getDataNodeAlarmLevel(dataNode) > 0) { // 信号量输入且告警等级为普通告警及以上返回告警状态
                      mapNode.valueText = this.$type.getResourceAlarmStateText(dataNode.resourceKind, dataNode.alarmState, dataNode.eventTypeSet,
                        1, dataNode.encoderAlarmState, dataNode.encoderEventTypeSet)
                    } else {
                      mapNode.valueText = this.$type.getResourceWorkStateText(dataNode.resourceKind, dataNode.gaugedObjectKind,
                        dataNode.guagedValue, null, dataNode.scaleFactor, dataNode.correctedValue, dataNode.valueType, dataNode.decimalDigit, '') // dataNode.dataUnit)
                    }
                    mapNode.resource = dataNode
                    this.lastUpdateDataNodeMapNodes.push(mapNode)
                  }
                })
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          resolve(err)
        })
      })
    },
    // 查询控制节点列表
    getControlNodeList() {
      return new Promise((resolve, reject) => {
        if (this.controlNodeMapNodeCount === 0) { // 地图节点不存在，直接返回
          resolve({})
          return
        }

        console.log('当前组态画面控制节点数量为' + this.controlNodeMapNodeCount)
        this.loading = true
        if (this.controlNodeQueryParams.nodeIds.length === 0) {
          this.mapNodes.forEach(item => { // 汇总控制节点id
            if ((item.resourceKind === 24 || item.resourceKind === 25) && item.resourceId > 0) {
              this.controlNodeQueryParams.nodeIds.push(item.resourceId)
            }
          })
          if (this.controlNodeQueryParams.nodeIds.length === 0) {
            this.loading = false
            resolve({})
            return
          }
        } else {
        }

        if (this.lastControlNodeUpdateDateTime > 0) {
          this.controlNodeQueryParams.beginUpdateDateTime = this.lastControlNodeUpdateDateTime + 1
        }

        this.$http(this.$api.controlNodeList, this.controlNodeQueryParams).then(
          res => {
            if (res.code === 200 && res.data.length) {
              if (this.controlNodes.length === 0) {
                this.controlNodes = res.data
              } else {
                res.data.forEach(item => { // 更新控制节点数据
                  for (let index in this.controlNodes) {
                    if (this.controlNodes[index].id === item.id) {
                      this.controlNodes[index] = item
                      break
                    }
                  }
                })
              }

              this.lastUpdateControlNodeMapNodes = []
              res.data.forEach(controlNode => {
                if (controlNode.updateDateTime > this.lastControlNodeUpdateDateTime) { // 更新最后更新日期时间
                  this.lastControlNodeUpdateDateTime = controlNode.updateDateTime
                }
                if (controlNode.dataNodeUpdateDateTime > this.lastControlNodeUpdateDateTime) { // 更新最后更新日期时间
                  this.lastControlNodeUpdateDateTime = controlNode.dataNodeUpdateDateTime
                }
                this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                  if (controlNode.id === mapNode.resourceId && controlNode.resourceKind === mapNode.resourceKind) {
                    if (controlNode.dataNodeGuagedValue) { // 根据关联的数据节点采集值设置控制数值
                      controlNode.controlValue = controlNode.dataNodeGuagedValue
                    }
                    if (controlNode.resourceKind === 24) { // 信号量输出
                      controlNode.controlState = this.$type.getResourceControlState(controlNode.resourceKind, controlNode.controlValue, controlNode.valueType) // 根据控制数值返回控制状态
                    } else if (controlNode.resourceKind === 25) { // 模拟量输出
                    }
                    mapNode.valueText = this.$type.getResourceControlStateText(controlNode.resourceKind, controlNode.controlledObjectKind, controlNode.controlValue,
                      controlNode.valueType, controlNode.dataNodeDecimalDigit, controlNode.dataNodeDataUnit)
                    mapNode.resource = controlNode
                    this.lastUpdateControlNodeMapNodes.push(mapNode)
                  }
                })
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          resolve(err)
        })
      })
    },
    // 查询实时事件列表
    getRealEventList() {
      return new Promise((resolve, reject) => {
        if (this.realEventMapNodeCount === 0) { // 地图节点不存在，直接返回
          resolve({})
          return
        }

        this.loading = true
        if (this.realEvents.length === 0) { // 首次加载
          getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
            let dates = getOneWeekBeginAndEndDate() // 近一周
            this.$http(this.$api.historyEventList, {
              lastEventId: 0,
              regionId: 0,
              objectId: 0,
              descendantRegionRequired: 1,
              resourceKind: 255,
              resourceSubType: 255,
              systemKind: 0, // 系统种类
              alarmStates: [],
              beginHappenDateTime: dates[0].getTime() / 1000,
              endHappenDateTime: dates[1].getTime() / 1000,
              handleStates: [], // 处理状态数组
              orderBy: 1, // 排序方式,0-增序，1-减序
              pageNum: 1,
              pageSize: 20
            }).then(res => {
              if (res.code === 200) {
                this.realEvents = res.data
                this.realEvents.forEach((item, index) => {
                  item.index = index + 1 > 9 ? String(index + 1) : '0' + String(index + 1)
                  item.regionName = this.getNameById(item.regionId, this.$globalData.regions)
                  item.happenTimeText = this.strDateTimeFromSTime_t(item.happenTime)
                  if (item.updateDateTime > this.lastRealEventUpdateDateTime) { // 更新最后更新日期时间
                    this.lastRealEventUpdateDateTime = item.updateDateTime
                  }
                })
                this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                  if (mapNode.resourceKind === 51) {
                    mapNode.resource = this.realEvents
                    this.lastUpdateRealEventsMapNodes.push(mapNode)
                  }
                })
              }
              this.loading = false
              resolve(res)
            }).catch(err => {
              console.log(err)
              this.loading = false
            })
          })
        } else { // 后续加载
          this.lastUpdateRealEventsMapNodes = []
          let hasNewEvent = false
          let realEvents = this.$store.getters.appNewEvents
          realEvents.forEach(event => {
            if (event.updateDateTime > this.lastRealEventUpdateDateTime) { // 更新最后更新日期时间
              this.lastRealEventUpdateDateTime = event.updateDateTime
              this.realEvents.unshift(event)
              hasNewEvent = true
            }
          })

          if (this.realEvents.length > 100) { // 删除大于100的元素
            this.realEvents.length = 100
          }
          if (!this.realEventMapNodeEventLoaded || hasNewEvent) { // 首次有事件返回或有新事件
            this.realEventMapNodeEventLoaded = true
            this.mapNodes.forEach(mapNode => { // 更新地图节点数值
              if (mapNode.resourceKind === 51) { // 事件集合
                mapNode.resource = this.realEvents
                this.lastUpdateRealEventsMapNodes.push(mapNode)
              }
            })
          }
          this.loading = false
          resolve({})
        }
      })
    },
    // 查询地图动作列表
    getMapActionList() {
      return new Promise((resolve, reject) => {
        if (this.mapActionMapNodeCount === 0) { // 地图节点不存在，直接返回
          resolve({})
          return
        }

        console.log('当前组态画面地图动作资源数量为' + this.mapActionMapNodeCount)
        this.loading = true
        if (this.lastMapActionUpdateDateTime > 0) {
          this.mapActionQueryParams.beginUpdateDateTime = this.lastMapActionUpdateDateTime + 1
        }

        this.$http(this.$api.mapActionList, this.mapActionQueryParams).then(
          res => {
            if (res.code === 200 && res.data.length) {
              if (this.mapActions.length === 0) {
                this.mapActions = res.data
              } else {
                res.data.forEach(item => { // 更新地图动作数据
                  for (let index in this.mapActions) {
                    if (this.mapActions[index].id === item.id) {
                      this.mapActions[index] = item
                      break
                    }
                  }
                })
              }

              this.lastUpdateMapActionMapNodes = []
              res.data.forEach(mapAction => {
                if (mapAction.updateDateTime > this.lastMapActionUpdateDateTime) { // 更新最后更新日期时间
                  this.lastMapActionUpdateDateTime = mapAction.updateDateTime
                }
                this.mapNodes.forEach(mapNode => { // 更新地图节点数值
                  if (mapNode.resourceKind === 71 && mapAction.id === mapNode.resourceId) {
                    // mapNode.valueText = mapAction.name
                    mapNode.resource = mapAction
                    this.lastUpdateMapActionMapNodes.push(mapNode)
                  }
                })
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          resolve(err)
        })
      })
    },
    // 加载顶层地图
    loadRootMap() {
      this.$refs.topologyMap.loadRootMap()
    },
    // 切换地图
    switchMap(mapId, regionId, systemKind) {
      if (mapId && mapId !== this.$refs.topologyMap.currentMapId) {
        this.$refs.topologyMap.loadMapByMapId(mapId)
      } else if (regionId) {
        this.$refs.topologyMap.loadMapByRegionId(regionId, systemKind)
      } else {
      }
    },
    // 地图加载完成
    handleMapLoad: function (map) {
      console.log('map load')
      this.getMapNodeList().then(res => {
        this.getRegionList().then(res => {
          this.getStreamNodeList().then(res => {
            this.getDataNodeList().then(res => {
              this.getControlNodeList().then(res => {
                this.getRealEventList().then(res => {
                  this.getMapActionList().then(res => {
                    this.topologyMap.loadMapNodeList(this.mapNodes)
                    if (this.textMapActionMapNodeCount > 0) { // 只有存在文本地图动作地图节点时才启动轮巡
                      // 开始文本动作轮巡
                      this.startTextMapActionPolling()
                    }
                    // 开始数据轮巡
                    this.startDataPolling()
                  })
                })
              })
            })
          })
        })
      })
    },
    // 地图将卸载
    handleMapReadyUnload: function (map) {
      console.log('map ready unload')
      // 停止数据轮巡
      this.stopDataPolling()
      if (this.textMapActionMapNodeCount > 0) {
        // 停止文本动作轮巡
        this.stopTextMapActionPolling()
      }
      this.lastRegionUpdateDateTime = 0
      this.regionQueryParams.beginUpdateDateTime = 0
      this.regionQueryParams.regionIds = []

      this.streamNodes = []
      this.lastStreamNodeUpdateDateTime = 0
      this.streamNodeQueryParams.beginUpdateDateTime = 0
      this.streamNodeQueryParams.nodeIds = []

      this.dataNodes = []
      this.lastDataNodeUpdateDateTime = 0
      this.dataNodeQueryParams.beginUpdateDateTime = 0
      this.dataNodeQueryParams.nodeIds = []

      this.controlNodes = []
      this.lastControlNodeUpdateDateTime = 0
      this.controlNodeQueryParams.beginUpdateDateTime = 0
      this.controlNodeQueryParams.nodeIds = []

      // this.realEvents = []
      // this.lastRealEventUpdateDateTime = 0
      this.realEventMapNodeEventLoaded = false

      // this.mapActions = []
      // this.lastMapActionUpdateDateTime = 0
      // this.mapActionQueryParams.beginUpdateDateTime = 0

      this.mapMapNodeCount = 0
      this.regionMapNodeCount = 0
      this.streamNodeMapNodeCount = 0
      this.dataNodeMapNodeCount = 0
      this.controlNodeMapNodeCount = 0
      this.realEventMapNodeCount = 0
      this.mapActionMapNodeCount = 0
      this.textMapActionMapNodeCount = 0
      this.mapNodes = []
    },
    // 节点单击
    handleNodeClick: function (mapNode) {
      this.currentRegion = null
      this.currentStreamNode = null
      this.currentDataNode = null
      this.currentDoControlNode = null
      this.currentAoControlNode = null
      this.currentRealEvents = null
      this.currentMapAction = null
      if (!mapNode.resource) {
        return
      }

      if (mapNode.resourceKind === 150) { // 区域
        this.currentRegion = mapNode.resource
      } else if (mapNode.resourceKind === 21) { // 视频节点
        this.currentStreamNode = mapNode.resource
      } else if (mapNode.resourceKind === 22) { // 信号量输入
        this.currentDataNode = mapNode.resource
      } else if (mapNode.resourceKind === 23) { // 模拟量输入
        this.currentDataNode = mapNode.resource
      } else if (mapNode.resourceKind === 24) { // 信号量输出
        this.currentDoControlNode = mapNode.resource
      } else if (mapNode.resourceKind === 25) { // 模拟量输出
        this.currentAoControlNode = mapNode.resource
      } else if (mapNode.resourceKind === 51) { // 事件集合
        this.currentRealEvents = mapNode.resource
      } else if (mapNode.resourceKind === 71) { // 地图动作
        this.currentMapAction = mapNode.resource
      }

      if (this.currentRegion) {
      } else if (this.currentStreamNode) {
        if (mapNode.modelKind === 0 || mapNode.modelKind === 8) { // 图片或文本
          this.handleStreamNodeView(this.currentStreamNode)
        } else if (mapNode.modelKind === 5) { // 视频
        }
      } else if (this.currentDataNode) {
        this.handleDataNodeView(this.currentDataNode)
      } else if (this.currentDoControlNode) {
        this.handleControlNodeStateChange(this.currentDoControlNode)
      } else if (this.currentAoControlNode) {
        this.handleControlNodeAdjustValue(this.currentAoControlNode)
      } else if (this.currentRealEvents) {
        this.handleRealEvents(this.currentRealEvents)
      } else if (this.currentMapAction) {
        this.handleMapAction(this.currentMapAction)
      }
    },
    // 查看视频节点信息
    handleStreamNodeView(streamNode) {
      if (streamNode) {
        this.activeStreamNodes = []
        this.activeStreamNodes.push(streamNode)
        if (!this.videoPlayerModalOpen) {
          this.videoPlayerModalOpen = true
        } else { // 重新打开视频
          this.videoPlayerModalVideoOpen = true
        }
      }
    },
    // 视频播放器窗口关闭
    handleVideoPlayerModalCancel() {
      this.videoPlayerModalOpen = false
    },
    // 查看数据节点信息
    handleDataNodeView(dataNode) {
      if (dataNode) {
        this.showDataNodeModalOpen = true
      }
    },
    // 数据节点信息取消提交
    handleShowDataNodeModalCancel() {
      this.showDataNodeModalOpen = false
    },
    // 处理控制节点控制状态改变单击
    handleControlNodeStateChange(controlNode) {
      if (controlNode == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      let queryText = controlNode.controlState === 0 ? '您确定打开【' : '您确定关闭【'
      queryText += controlNode.name
      queryText += '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: controlNode.id,
          controlCmd: controlNode.controlState === 0 ? 0 : 1 // 控制命令，0-打开，1-关闭，2-禁止关(常开)，3-禁止开(常闭)，4-恢复普通模式(允许开关)
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              controlNode.controlValue = controlNode.controlValue === 0 ? 1 : 0
              controlNode.controlState = this.$type.getResourceControlState(controlNode.resourceKind, controlNode.controlValue, controlNode.valueType) // 根据控制数值返回控制状态

              this.mapNodes.forEach(mapNode => { // 更新关联当前控制节点资源的地图节点
                if (controlNode.id === mapNode.resourceId && controlNode.resourceKind === mapNode.resourceKind) {
                  mapNode.valueText = this.$type.getResourceControlStateText(controlNode.resourceKind, controlNode.controlledObjectKind, controlNode.controlValue,
                    controlNode.valueType, controlNode.dataNodeDecimalDigit, controlNode.dataNodeDataUnit)
                  mapNode.resource = controlNode
                  this.topologyMap.updateTpNode(mapNode)
                }
              })
              if (controlNode.dataNodeId > 0) { // 检测是否关联数据节点
                let dataNode = this.getRecordById(controlNode.dataNodeId, this.dataNodes)
                this.mapNodes.forEach(mapNode => { // 更新关联当前数据节点资源的地图节点
                  if (dataNode && dataNode.id === mapNode.resourceId && dataNode.resourceKind === mapNode.resourceKind) {
                    dataNode.guagedValue = controlNode.controlValue
                    mapNode.valueText = this.$type.getResourceWorkStateText(dataNode.resourceKind, dataNode.gaugedObjectKind,
                      dataNode.guagedValue, null, dataNode.scaleFactor, dataNode.correctedValue, dataNode.valueType, dataNode.decimalDigit, '') // dataNode.dataUnit)
                    mapNode.resource = dataNode
                    this.topologyMap.updateTpNode(mapNode)
                  }
                })
              }
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 处理控制节点调整数值点击
    handleControlNodeAdjustValue(controlNode) {

    },
    // 处理事件集合单击
    handleRealEvents(events) {
      this.eventsModalOpen = true
    },
    // 事件集合取消提交
    handleEventsModalCancel() {
      this.eventsModalOpen = false
    },
    // 处理地图动作点击
    handleMapAction(mapAction) {
      if (mapAction.actionType === 240) { // 退出
        window.opener = null // 如果没有这行和下面的一行则会出现上面的第二个询问框。
        window.open(' ', '_self', ' ')
        window.close()
        // window.location.href = 'about:blank'
        // window.close()
      } else {
      }
    },
    // 开始文本动作轮巡
    startTextMapActionPolling() {
      this.stopTextMapActionPolling()
      this.textMapActionPollingTimes = 0
      this.textMapActionPollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }

        let mapUpdateRequired = false
        this.textMapActionMapNodes.forEach(mapNode => { // 更新地图节点数值
          if (mapNode.resource) {
            if (mapNode.resource.actionType === 104) { // 资源数量统计
              if (this.textMapActionPollingTimes % 120 === 0) {
                if (Number(mapNode.resource.actionParam1) === 150) { // 区域
                  this.regionLoadRequired = true // 区域需加载
                }
                mapNode.valueText = statResourceCount(Number(mapNode.resource.actionParam1),
                  Number(mapNode.resource.actionParam2), Number(mapNode.resource.actionParam3), this.$globalData.regions).toString()
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else if (mapNode.resource.actionType === 105) { // 正常资源数量统计
              if (this.textMapActionPollingTimes % 120 === 0) {
                if (Number(mapNode.resource.actionParam1) === 150) { // 区域
                  this.regionLoadRequired = true // 区域需加载
                }
                mapNode.valueText = statNormalResourceCount(Number(mapNode.resource.actionParam1),
                  Number(mapNode.resource.actionParam2), Number(mapNode.resource.actionParam3), this.$globalData.regions).toString()
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else if (mapNode.resource.actionType === 106) { // 离线资源数量统计
              if (this.textMapActionPollingTimes % 120 === 0) {
                if (Number(mapNode.resource.actionParam1) === 150) { // 区域
                  this.regionLoadRequired = true // 区域需加载
                }
                mapNode.valueText = statOfflineResourceCount(Number(mapNode.resource.actionParam1),
                  Number(mapNode.resource.actionParam2), Number(mapNode.resource.actionParam3), this.$globalData.regions).toString()
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else if (mapNode.resource.actionType === 107) { // 报警资源数量统计
              if (this.textMapActionPollingTimes % 120 === 0) {
                if (Number(mapNode.resource.actionParam1) === 150) { // 区域
                  this.regionLoadRequired = true // 区域需加载
                }
                mapNode.valueText = statAlarmResourceCount(Number(mapNode.resource.actionParam1),
                  Number(mapNode.resource.actionParam2), Number(mapNode.resource.actionParam3), this.$globalData.regions).toString()
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else if (mapNode.resource.actionType === 170) { // 当前日期时间
              mapNode.valueText = new Date().Format('yyyy年MM月dd日 hh时mm分ss秒')
              this.topologyMap.updateTpNode(mapNode)
              mapUpdateRequired = true
            } else if (mapNode.resource.actionType === 171) { // 当前日期
              if (this.textMapActionPollingTimes % 120 === 0) {
                mapNode.valueText = new Date().Format('yyyy年MM月dd日')
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else if (mapNode.resource.actionType === 172) { // 当前时间
              mapNode.valueText = new Date().Format('hh时mm分ss秒')
              this.topologyMap.updateTpNode(mapNode)
              mapUpdateRequired = true
            } else if (mapNode.resource.actionType === 173) { // 当前星期
              if (this.textMapActionPollingTimes % 120 === 0) {
                mapNode.valueText = getDayTextOfWeek()
                this.topologyMap.updateTpNode(mapNode)
                mapUpdateRequired = true
              }
            } else {
            }
          }
        })

        if (mapUpdateRequired) {
          this.topologyMap.refreshMap()
        }
        ++this.textMapActionPollingTimes
      }, 500)
    },
    // 停止文本动作轮巡
    stopTextMapActionPolling() {
      if (this.textMapActionPollingTimer != null) {
        clearInterval(this.textMapActionPollingTimer)
        this.textMapActionPollingTimer = null
        this.textMapActionPollingTimes = 0
      }
    },
    // 开始数据轮巡
    startDataPolling() {
      this.stopDataPolling()
      this.pollingTimes = 0
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }

        let mapUpdateRequired = false
        if (this.pollingTimes % 6 === 0) {
          // 查询区域列表
          this.getRegionList().then(res => {
            this.lastUpdateRegionMapNodes.forEach(mapNode => { // 更新地图节点
              this.topologyMap.updateTpNode(mapNode)
            })
            if (this.lastUpdateRegionMapNodes.length) {
              mapUpdateRequired = true
              this.lastUpdateRegionMapNodes = []
            }

            // 查询视频节点状态列表
            this.getStreamNodeList().then(res => {
              this.lastUpdateStreamNodeMapNodes.forEach(mapNode => { // 更新地图节点
                this.topologyMap.updateTpNode(mapNode)
              })
              if (this.lastUpdateStreamNodeMapNodes.length) {
                mapUpdateRequired = true
                this.lastUpdateStreamNodeMapNodes = []
              }
            })
          })
        }

        // 查询数据节点状态列表
        this.getDataNodeList().then(res => {
          this.lastUpdateDataNodeMapNodes.forEach(mapNode => { // 更新地图节点
            this.topologyMap.updateTpNode(mapNode)
          })
          if (this.lastUpdateDataNodeMapNodes.length) {
            mapUpdateRequired = true
            this.lastUpdateDataNodeMapNodes = []
          }

          // 查询控制节点状态列表
          this.getControlNodeList().then(res => {
            this.lastUpdateControlNodeMapNodes.forEach(mapNode => { // 更新地图节点
              this.topologyMap.updateTpNode(mapNode)
            })
            if (this.lastUpdateControlNodeMapNodes.length) {
              mapUpdateRequired = true
              this.lastUpdateControlNodeMapNodes = []
            }

            // 查询实时事件列表
            this.getRealEventList().then(res => {
              this.lastUpdateRealEventsMapNodes.forEach(mapNode => { // 更新地图节点
                this.topologyMap.updateTpNode(mapNode)
              })
              if (this.lastUpdateRealEventsMapNodes.length) {
                mapUpdateRequired = true
                this.lastUpdateRealEventsMapNodes = []
              }
            })
          })
        })

        if (mapUpdateRequired) {
          this.topologyMap.refreshMap()
        }
        ++this.pollingTimes
      }, 10000)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
        this.pollingTimes = 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/mapNavigator/MapNavigator.js